import { render, staticRenderFns } from "./EduCourseCategory.vue?vue&type=template&id=d35cf4a2&scoped=true&"
import script from "./EduCourseCategory.vue?vue&type=script&lang=js&"
export * from "./EduCourseCategory.vue?vue&type=script&lang=js&"
import style0 from "./EduCourseCategory.vue?vue&type=style&index=0&id=d35cf4a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35cf4a2",
  null
  
)

export default component.exports